export default __webpack_public_path__ + "static/media/case-li1.8a10d139.png";